import {API_COMPANY} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getAll = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_COMPANY,
    });
    return res.data;
  } catch (error) {
    console.error('companyApi getAll Error:', error.message);
    return null;
  }
};

const companyApi = {
  getAll
}

export default companyApi;